import React, { useEffect, useState } from 'react';
import { add, getDay, getHours, startOfDay } from 'date-fns';
import moment from 'moment';
import JobFormPage from '../JobFormPage';
import { useJobFormContext } from 'parent-portal/forms/JobFormContext';
import { TemplateOption } from 'parent-portal/forms/JobRequestTypes';
import BusinessDatesAndTimes from './BusinessDatesAndTimes';

function getDefaultJobDate() {
    const now = new Date();
    let date = startOfDay(getHours(now) < 13 ? now : add(now, { days: 1 }));
    const day = getDay(date);
    if (day === 6) date = add(date, { days: 2 });
    if (day === 0) date = add(date, { days: 1 });
    return moment(date);
}

export default function BusinessDateAndTimePage({ name }: { name: string }) {
    const [isValid, setIsValid] = useState(false);
    const { goToNext, currentPage, form } = useJobFormContext();
    const { startDate, endDate, useTemplate } = form.fieldStates;

    useEffect(() => {
        if (useTemplate.value !== TemplateOption.TEMPLATE && !startDate.value) {
            const defaultDate = getDefaultJobDate();
            startDate.setValue(defaultDate);
            endDate.setValue(defaultDate);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <JobFormPage
            title="When is your job?"
            onNextClicked={() => goToNext(name)}
            backText={currentPage === 0 ? 'Cancel' : 'Back'}
            nextDisabled={!isValid}
            id={name}
        >
            <BusinessDatesAndTimes setIsValid={setIsValid} />
        </JobFormPage>
    );
}
